import * as yup from 'yup'
import { createDataRef, createDataSchema } from '../schemaUtils'
import { ImageSchema } from './Image.schema'
import { VideoSchema } from './Video.schema'
import { cssStyle } from '../css/Css.schema'

import { alignmentSchemaField, filterEffectSchemaObject, fittingSchemaField } from './mediaCommon.schema'

const scroll = [...(['none', 'fixed', 'scroll', 'local', 'parallax'] as const)]
type Scroll = typeof scroll[number]

const blendMode = [
	...([
		'normal',
		'multiply',
		'screen',
		'darken',
		'lighten',
		'overlay',
		'colorDodge',
		'colorBurn',
		'hardLight',
		'softLight',
		'difference',
		'exclusion',
		'hue',
		'saturation',
		'color',
		'luminosity',
	] as const),
]
type BlendMode = typeof blendMode[number]

const BackgroundTransforms = yup.object({
	scale: yup.number().min(0),
	opacity: yup.number().min(0).max(1),
})

export const overlayBlending = yup.object({
	color: yup.string(),
	opacity: yup.number().min(0).max(1),
	contrast: yup.number().min(0).max(2),
	saturate: yup.number().min(0).max(2),
	blendMode: yup.mixed<BlendMode>().oneOf(blendMode).default(blendMode[0]),
})

export const BackgroundMediaSchema = createDataSchema(
	'BackgroundMedia',
	yup.object({
		mediaRef: createDataRef({
			Image: ImageSchema,
			Video: VideoSchema,
		}).notRequired(),
		mediaTransforms: BackgroundTransforms.notRequired(),
		overlayTransforms: BackgroundTransforms.notRequired(),
		imageOverlay: createDataRef({ ImageOverlay: ImageSchema }).notRequired(),
		...alignmentSchemaField,
		...fittingSchemaField,
		scrollType: yup.mixed<Scroll>().oneOf(scroll).default(scroll[0]),
		showOverlayForMediaType: yup
			.mixed<'all' | 'WixVideo' | 'Image'>()
			.oneOf(['all', 'WixVideo', 'Image'])
			.default('WixVideo'),
		color: yup.string(),
		colorOpacity: yup.number(),
		colorOverlay: yup.string(),
		colorOverlayOpacity: yup.number(),
		overlayBlending: overlayBlending.notRequired(),
		filterEffect: filterEffectSchemaObject.notRequired(),
	})
)

export const mediaContainerDesignSchema = createDataSchema(
	'MediaContainerDesignData',
	yup.object({
		charas: yup.string().nullable(),
		background: createDataRef({
			BackgroundMedia: BackgroundMediaSchema,
		}).nullable(),
		dataChangeBehaviors: yup
			.array()
			.of(
				yup.object({
					trigger: yup.string(),
					type: yup.string(),
					part: yup.string(),
					name: yup.string(),
					params: yup.object({
						duration: yup.number(),
					}),
				})
			)
			.nullable(),
		cssStyle: cssStyle.default(undefined),
		themeMappings: yup.object(),
	})
)
